import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { FilterPipelineFilter } from 'record-it-components/hooks/useFilterPipeline/useFilterPipeline';
import { SearchableSelect } from 'record-it-components/input/SearchableSelect/SearchableSelect';
export enum ArchivedFilterValue {
  All = 'all',
  OnlyArchived = 'onlyArchived',
  NotArchived = 'notArchived',
}
export const archivedFilter: FilterPipelineFilter<ArchivedFilterConstraint, ArchivedFilterValue> = {
  defaultValue: ArchivedFilterValue.NotArchived,
  filter: (item, value) => {
    switch (value) {
      case ArchivedFilterValue.All:
        return true;
      case ArchivedFilterValue.NotArchived:
        return !item.archived;
      case ArchivedFilterValue.OnlyArchived:
        return item.archived;
      default:
        throw new Error(`unhandled filter choice ${value}`);
    }
  },
  Component: ({
    value,
    setValue
  }) => {
    const {
      t
    } = useTranslation();
    const items = useMemo<[ArchivedFilterSelectItem, ArchivedFilterSelectItem, ArchivedFilterSelectItem]>(() => {
      return [{
        text: t('filters.archivedFilter.all'),
        value: ArchivedFilterValue.All
      }, {
        text: t('filters.archivedFilter.notArchived'),
        value: ArchivedFilterValue.NotArchived
      }, {
        text: t('filters.archivedFilter.onlyArchived'),
        value: ArchivedFilterValue.OnlyArchived
      }];
    }, [t]);
    const selectedItem = items.find(i => i.value === value) ?? items[0];
    const handleValueChanged = useEventCallback((item: ArchivedFilterSelectItem) => {
      setValue(item.value);
    });
    return <SearchableSelect<ArchivedFilterSelectItem> items={items} getDisplayTextOfItem={getDisplayTextOfItem} getKeyOfItem={getKeyOfItem} label={t('filters.archivedFilter.label')} value={selectedItem} onValueChanged={handleValueChanged} data-testid="archivedFilter.Select"></SearchableSelect>;
  }
};
function getDisplayTextOfItem(item: ArchivedFilterSelectItem): string {
  return item.text;
}
function getKeyOfItem(item: ArchivedFilterSelectItem): string {
  return item.value;
}
export type ArchivedFilterConstraint = {
  archived: boolean;
};
type ArchivedFilterSelectItem = {
  text: string;
  value: ArchivedFilterValue;
};